import { useState } from "react";
import { SubCheckoutCreateYourAccountEntry } from "~/components/SubCheckoutV2/SubCheckoutCreateYourAccountEntry";
import { SubCheckoutCreateYourAccountForm } from "~/components/SubCheckoutV2/SubCheckoutCreateYourAccountForm";
import { SubCheckoutCreateYourAccountVerify } from "~/components/SubCheckoutV2/SubCheckoutCreateYourAccountVerify";

export enum CreateYourAccountStep {
  ENTRY = 0,
  FORM = 1,
  VERIFY = 2,
}

export type SubCheckoutPageAccountStepProps = {
  activeStep: CreateYourAccountStep;
  setActiveStep: (step: CreateYourAccountStep) => void;
  postLoginRedirect: string;
};

export const SubCheckoutPageCreateYourAccount: React.FC<
  SubCheckoutPageAccountStepProps
> = ({ activeStep, setActiveStep, postLoginRedirect }) => {
  const [submittedEmail, setSubmittedEmail] = useState<string>("");

  switch (activeStep) {
    case CreateYourAccountStep.FORM:
      return (
        <SubCheckoutCreateYourAccountForm
          onFormSubmit={({ email }) => {
            setActiveStep(CreateYourAccountStep.VERIFY);
            setSubmittedEmail(email);
          }}
          onBackClick={() => setActiveStep(CreateYourAccountStep.ENTRY)}
          postLoginRedirect={postLoginRedirect}
        />
      );
    case CreateYourAccountStep.VERIFY:
      return (
        <SubCheckoutCreateYourAccountVerify
          email={submittedEmail}
          onBackClick={() => setActiveStep(CreateYourAccountStep.FORM)}
        />
      );
    case CreateYourAccountStep.ENTRY:
    default:
      return (
        <SubCheckoutCreateYourAccountEntry
          onEmailSignUp={() => setActiveStep(CreateYourAccountStep.FORM)}
          postLoginRedirect={postLoginRedirect}
        />
      );
  }
};
